import ApiException from '@components/exceptions/ApiExceptions'
import axios from 'axios'
import * as branchesSlice from '../store/BranchesSlice'

const handleApiError = (error: any) => {
    const statusCode = error?.response?.status;
    const errorMessage = error?.response?.data?.detail;
    throw new ApiException(statusCode, errorMessage);
}
export const getAllBranches = async () => {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/branches`)
        return result.data
    } catch (error: any) {
        handleApiError(error);
    }

}
export const createBranch = async (params: branchesSlice.Branch) => {
    try {
        const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/branches`, params)
        return result.data
    } catch (error: any) {
        handleApiError(error);
    }

}
export const updateBranch = async (params: branchesSlice.Branch) => {
    try {
        const result = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/branches/${params.id}`, params)
        return result.data;
    } catch (error: any) {
        handleApiError(error);
    }

}
export const deleteBranch = async (params: branchesSlice.Branch) => {
    try {
        const result = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/branches/${params.id}`)
        return result;
    } catch (error: any) {
        handleApiError(error);
    }
}